import { useTranslation } from 'react-i18next'

import { RequestStatusBadge } from '@ps/common-features/components/request-status-badge/RequestStatusBadge'
import { Item, ItemContent, ItemDescription, ItemTitle } from '@ps/ds/components/blocks/Item/Item'
import { Avatar } from '@ps/ds/components/primitives/Avatar/Avatar'
import { PestShareLogo } from '@ps/ds/icons/PestShareLogo'
import { GROUPED_REQUEST_STATUS } from 'src/api/constants/request'
import type { GroupedRequestStatus } from 'src/api/types/requests'
import { NS } from 'src/constants/i18n'
import { formatLocalizedDate } from 'src/utils/date/formatLocalizedDate'

type RequestDetailsCardProps = {
  requestNumber: number
  submittedAt: string
  groupedRequestStatus: GroupedRequestStatus
}

export const RequestDetailsCard = ({
  requestNumber,
  submittedAt,
  groupedRequestStatus,
}: RequestDetailsCardProps) => {
  const { t, i18n } = useTranslation(NS.TRACKING)
  const formattedSubmittedDate = formatLocalizedDate(submittedAt, i18n.language)

  return (
    <Item variant="outline" className="items-start gap-4 px-4 py-5">
      <Avatar size="xl" className="items-center justify-center rounded-[8px] bg-gradient-orange">
        <PestShareLogo className="text-white" aria-hidden="true" />
      </Avatar>
      <ItemContent className="gap-1.5">
        <ItemTitle>{t('track.requestNumber', { number: requestNumber })}</ItemTitle>
        <ItemDescription>
          {t('track.submittedAt', {
            date: formattedSubmittedDate,
          })}
        </ItemDescription>
        {groupedRequestStatus !== GROUPED_REQUEST_STATUS.UNKNOWN && (
          <div className="mt-0.5 self-start">
            <RequestStatusBadge status={groupedRequestStatus}>
              {t(`track.statuses.${groupedRequestStatus}`)}
            </RequestStatusBadge>
          </div>
        )}
      </ItemContent>
    </Item>
  )
}
